import * as React from 'react';

import AsyncJobStartedDialog from 'bundles/enterprise-admin-learners/components/AsyncJobStartedDialog';
import { LEARNERS_MODAL } from 'bundles/enterprise-admin-learners/utils/eventing';

import _t from 'i18n!nls/enterprise-admin-learners';

export type AsyncCsvSubmissionModalProps = {
  open: boolean;
  /** Closes the whole invite flow, not just this screen. */
  onClose: () => void;
  /** Set when this CSV is adding existing learners to a group rather than inviting new ones. */
  isAddToGroupFlow?: boolean;
};

/**
 * Non-blocking confirmation shown once `ProcessImportAsync` has started a job — there's no
 * per-row result yet, only a job-started response, so this just tells the admin the job is
 * running in the background and lets them dismiss the flow.
 */
const AsyncCsvSubmissionModal = ({ open, onClose, isAddToGroupFlow }: AsyncCsvSubmissionModalProps) => (
  <AsyncJobStartedDialog
    open={open}
    onClose={onClose}
    width="large"
    heading={isAddToGroupFlow ? _t("We're adding learners to group") : _t("We're sending your invites")}
    notificationTitle={isAddToGroupFlow ? undefined : _t("You'll get an email once all invitations are sent.")}
    modalName={isAddToGroupFlow ? LEARNERS_MODAL.INVITE_TO_GROUP_ASYNC : LEARNERS_MODAL.INVITE_ASYNC}
  />
);

export default AsyncCsvSubmissionModal;
